import { CreateReplyDto } from '@diritto/common/reply/dtos/create-reply.dto';
import { ReplyResponseDto } from '@diritto/common/reply/dtos/reply.response.dto';
import { EpisodeReplyApi } from 'api/ApiHelper';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useCreateEpisodeReplyMutation = (
  contentId: number,
  episodeId: number,
  options?: UseMutationOptions<ReplyResponseDto, unknown, CreateReplyDto>,
) =>
  useMutation({
    mutationFn: (replyDto: CreateReplyDto) => EpisodeReplyApi.createReply(contentId, episodeId, replyDto),
    ...options,
  });
